
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import Abpbase from '@/lib/abpbase'
import RightPanel from '@/components/right-panel/index.vue'
import WorkingZone from '@/entities/workzone'

@Component({
  components: {
    RightPanel
  }
})
export default class WorkingZonePanel extends Abpbase {
  name: 'WorkingZonePanel'

  @Prop({
    type: Object,
    default: () => {}
  })
  item: WorkingZone

  loading: boolean = false

  info: WorkingZone = new WorkingZone()

  async getDetailById() {
    if (!this.item || !this.item.id) {
      this.$message.warning('Data Exception')
      return
    }
    try {
      this.loading = true
      let res = await this.$store.dispatch({
        type: 'workingzone/getDetailById',
        id: this.item.id
      })
      this.info = res || {}
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }

  @Watch('item', { deep: true, immediate: true })
  onItemChanged() {
    this.getDetailById()
  }

  @Emit('close')
  doExpandClose() {}

  @Emit('delete')
  doDelete() {
    return this.item.id
  }

  @Emit('edit')
  doEdit() {
    return this.item.id
  }
}
